export interface VariableJSON {
  submission: number;
  name: string;
  year: number;
  value: number;
  key: string;
  disabled: boolean;
  showInGui: boolean;
}

export class Variable {
  #value: number;

  constructor(
    public readonly submission: number,
    public readonly name: string,
    public readonly year: number,
    value: number,
    public readonly key: string,
    public disabled: boolean,
    public readonly showInGui: boolean,
  ) {
    this.#value = value;
  }

  get value() {
    return this.#value;
  }

  setValue(value: number) {
    this.#value = value;
    return this;
  }

  toJSON(): VariableJSON {
    return {
      submission: this.submission,
      name: this.name,
      year: this.year,
      value: this.value,
      key: this.key,
      disabled: this.disabled,
      showInGui: this.showInGui,
    }
  }

  static fromJSON(json: VariableJSON): Variable {
    return new Variable(
      json.submission,
      json.name,
      json.year,
      json.value,
      json.key,
      json.disabled,
      json.showInGui,
    )
  }
}